<div *ngIf="results.length === 0 && !isLoading" class="alert alert-info">
  {{ emptyMessage }}
</div>

<div *ngIf="results.length > 0">
  <div class="list-group">
    <div *ngFor="let result of paginatedResults"
         class="list-group-item list-group-item-action search-result-item"
         [attr.role]="selectable ? 'button' : null"
         [attr.tabindex]="selectable ? 0 : null"
         (click)="onSelect(result.id)">
      <div class="d-flex w-100 justify-content-between mb-2">
        <h6 class="mb-1">Question #{{ result.id }}</h6>
        <small class="text-muted">{{ result.subjectName }}</small>
      </div>
      <div *ngIf="(badgesById[result.id]?.length || 0) > 0" class="mb-2">
        <span *ngFor="let badge of (badgesById[result.id] || [])"
              class="badge rounded-pill me-1"
              [ngClass]="badgeClass(badge)">
          {{ badge }}
        </span>
      </div>
      <div *ngIf="showMatchedField && result.matchedField" class="mb-2">
        <small class="text-muted">Matched in: <strong>{{ result.matchedField }}</strong></small>
      </div>
      <p class="mb-1 search-result-text" [innerHTML]="displayHtmlById[result.id] || ''"></p>
    </div>
  </div>

  <!-- Pagination -->
  <nav *ngIf="showPagination && results.length > itemsPerPage" aria-label="Results pagination" class="mt-4">
    <ul class="pagination justify-content-center">
      <li class="page-item" [class.disabled]="currentPage === 1">
        <a class="page-link" href="#" (click)="previousPage(); $event.preventDefault()" aria-label="Previous">
          <span aria-hidden="true">&laquo;</span>
        </a>
      </li>
      <li *ngFor="let page of pageNumbers" class="page-item" [class.active]="page === currentPage">
        <a class="page-link" href="#" (click)="goToPage(page); $event.preventDefault()">{{ page }}</a>
      </li>
      <li class="page-item" [class.disabled]="currentPage === totalPages">
        <a class="page-link" href="#" (click)="nextPage(); $event.preventDefault()" aria-label="Next">
          <span aria-hidden="true">&raquo;</span>
        </a>
      </li>
    </ul>
    <div class="text-center text-muted small mt-2">
      Showing {{ (currentPage - 1) * itemsPerPage + 1 }} - {{ Math.min(currentPage * itemsPerPage, results.length) }} of {{ results.length }} results
    </div>
  </nav>
</div>

